import React, { useState, useEffect, useMemo, useRef } from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useSelector, useDispatch } from "react-redux";
import "survey-core/defaultV2.min.css";
import "./index.css";
import { Auth } from 'aws-amplify';
import { themeJson } from "./themejson";
import * as XLSX from "xlsx";
import { useParams } from 'react-router-dom';

import { getUserSurveyFromAPI, updateUserSurveyFromAPI } from '../../../services/UserSurveyService';
import { updateSurveyResultFromAPI, completeSurveyResultFromAPI } from '../../../services/surveyResultService';

function UserSurveyComponent() {
    const topMenuTabs = useSelector((state) => state.topMenuTabs);

    const { user_survey_id } = useParams();

    const [userSurvey, setUserSurvey] = useState([]);
    const userSurveyRef = useRef(userSurvey);
    const [page404, setPage404] = useState(null);
    const [surveyJson, setSurveyJson] = useState({});
    const surveyJsonRef = useRef(surveyJson);
    const intervalRef = useRef(null);
    const [surveyResultsExcel,setSurveyResultExcel] = useState([])
    const currentSurveyResult = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurveyResult;
    console.log("currentSurveyResult",currentSurveyResult)
    const currentSurvey = topMenuTabs.tabs.find(
        (tab) => tab.id === topMenuTabs.activeTab
    ).states.currentSurvey;
    const arrangeSurvey = (surveyCopy) => {
    const _currentSurvey = JSON.parse(JSON.stringify(surveyCopy));
       if (_currentSurvey.asIsToBe) {
         _currentSurvey.pages.filter(x => x.name !== "intro" && x.type !== "demographics").forEach((page) => {
           page.elements[0].elements.forEach((element) => {
             if (element.type === "panel") {
               element.elements.forEach((subElement) => {
                 if (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating") {
                  const tempType = subElement.type
                  subElement.type = "matrixdropdown";
                  subElement.titleLocation = "hidden";
                  subElement.columns = []
                  if (tempType !== "rating"){
                    subElement.columns = [
                     {
                       name: subElement.name,
                       title: subElement.title,
                       cellType: tempType,
                       choices: subElement.choices
                     },
                    ]
                  }else{
                     subElement.columns = [
                      {
                        name: subElement.name,
                        title: subElement.title,
                        cellType: tempType,
                        rateCount: subElement.rateCount,
                        rateType: subElement.rateType,
                        rateMax : subElement.rateMax,
                        displayMode : subElement.buttons
                      },
                    ]
                  }
                  subElement.rows = [
                    { text: "Current", value: "Current" },
                    { text: "Target", value: "Target" }
                  ]
                  subElement.transposeData = true;
                 }
               });
             }else if (element.type === "paneldynamic") {
                const valueObj = {};
                element.templateElements.forEach((te) => {
                    
                    valueObj[te.name] = ""; // boş başlangıç değeri
                });

                element.value = [valueObj];
                element.panelCount = 1  
                element.readOnly= false
                element.allowAddPanel= false
                element.allowRemovePanel=false
                
               element.templateElements.forEach((subElement) => {
                  delete subElement.editing_type;
                  delete subElement.elements;
                  delete subElement.editing_elements;
                  delete subElement.editing_name;
                  delete subElement.editing_type;
                  delete subElement.editing_asIsToBe
                  delete subElement.editing_weight;
                  delete subElement.weight;
                  delete subElement.is_exist;    
                  delete subElement.isEditing;
                  subElement.visible = true
                  subElement.title =subElement.title
                  if (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating"){
                    const tempType = subElement.type
                    subElement.type = "matrixdropdown";
                    subElement.titleLocation = "hidden";
                    subElement.columns = []
                    if (tempType !== "rating"){
                      subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          choices: subElement.choices
                        },
                      ]
                    }else{
                       subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          rateCount: subElement.rateCount,
                          rateType: subElement.rateType,
                          rateMax : subElement.rateMax,
                          displayMode : subElement.buttons
                        },
                      ]
                    }
                   
                    subElement.rows = [
                      { text: "Current", value: "Current" },
                      { text: "Target", value: "Target" }
                    ]
                    subElement.transposeData = true;
                  }else if(subElement.type==="paneldynamic"){
                      const valueObj = {};
                      subElement.templateElements.forEach((te) => {
                          valueObj[te.name] = ""; // boş başlangıç değeri
                          delete te.editing_type;
                          delete te.elements;
                          delete te.editing_elements;
                          delete te.editing_name;
                          delete te.editing_type;
                          delete te.editing_asIsToBe
                          delete te.editing_weight;
                          delete te.weight;
                          delete te.is_exist;    
                          delete te.isEditing;
                          te.visible = true
                          te.title =te.title
                          if (te.type === "radiogroup" || te.type === "dropdown" || te.type === "rating"){
                            const tempType = te.type
                            te.type = "matrixdropdown";
                            te.titleLocation = "hidden";
                            te.columns = []
                            if (tempType !== "rating"){
                              te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  choices: te.choices
                                },
                              ]
                            }else{
                               te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  rateCount: te.rateCount,
                                  rateType: te.rateType,
                                  rateMax : subElement.rateMax,
                                  displayMode : subElement.buttons
                                },
                              ]
                            }
                           
                            te.rows = [
                              { text: "Current", value: "Current" },
                              { text: "Target", value: "Target" }
                            ]
                            te.transposeData = true;
                          }

                      });

                      subElement.value = [valueObj];
                      subElement.panelCount = 1  
                      subElement.readOnly= false
                      subElement.allowAddPanel= false
                      subElement.allowRemovePanel=false
                    }
               });
             }
           });
         }); 
       } else {
         _currentSurvey.pages.filter(x => x.name !== "intro" && x.type !== "demographics").forEach((page) => {
           page.elements[0].elements.forEach((element) => {
             if (element.type === "panel") {
               element.elements.forEach((subElement) => {
                if (subElement.asIsToBe && (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating")){
                  const tempType = subElement.type
                  subElement.type = "matrixdropdown";
                  subElement.titleLocation = "hidden";
                  subElement.columns = []
                  if (tempType !== "rating"){
                    subElement.columns = [
                     {
                       name: subElement.name,
                       title: subElement.title,
                       cellType: tempType,
                       choices: subElement.choices
                     },
                    ]
                  }else{
                     subElement.columns = [
                      {
                        name: subElement.name,
                        title: subElement.title,
                        cellType: tempType,
                        rateCount: subElement.rateCount,
                        rateType: subElement.rateType,
                        rateMax : subElement.rateMax,
                        displayMode : subElement.buttons
                      },
                    ]
                  }
                  subElement.rows = [
                    { text: "Current", value: "Current" },
                    { text: "Target", value: "Target" }
                  ]
                  subElement.transposeData = true;
                }
                else if (subElement.type === "matrixdropdown") {
                   subElement.type =  subElement.columns[0].cellType;
                   subElement.titleLocation = "top";
                   subElement.choices = subElement.columns[0].choices;
                   delete subElement.rows;
                   delete subElement.columns;
                   delete subElement.transposeData;
                 }
               });
             }else if (element.type === "paneldynamic") {
                const valueObj = {};
                element.templateElements.forEach((te) => {
                    
                    valueObj[te.name] = ""; // boş başlangıç değeri
                });

                element.value = [valueObj];
                element.panelCount = 1  
                element.readOnly= false
                element.allowAddPanel= false
                element.allowRemovePanel=false
                
               element.templateElements.forEach((subElement) => {
                  delete subElement.editing_type;
                  delete subElement.elements;
                  delete subElement.editing_elements;
                  delete subElement.editing_name;
                  delete subElement.editing_type;
                  delete subElement.editing_asIsToBe
                  delete subElement.editing_weight;
                  delete subElement.weight;
                  delete subElement.is_exist;    
                  delete subElement.isEditing;
                  subElement.visible = true
                  subElement.title =subElement.title
                  if (subElement.asIsToBe && (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating")){
                    const tempType = subElement.type
                    subElement.type = "matrixdropdown";
                    subElement.titleLocation = "hidden";
                    subElement.columns = []
                    if (tempType !== "rating"){
                      subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          choices: subElement.choices
                        },
                      ]
                    }else{
                       subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          rateCount: subElement.rateCount,
                          rateType: subElement.rateType,
                          rateMax : subElement.rateMax,
                          displayMode : subElement.buttons
                        },
                      ]
                    }
                   
                    subElement.rows = [
                      { text: "Current", value: "Current" },
                      { text: "Target", value: "Target" }
                    ]
                    subElement.transposeData = true;
                  }
                  else if (subElement.type === "matrixdropdown") {
                    subElement.type =  subElement.columns.cellType;
                    subElement.titleLocation = "top";
                    subElement.choices = subElement.columns[0].choices;
                    delete subElement.rows;
                    delete subElement.columns;
                    delete subElement.transposeData;
                    delete subElement.editing_type;
                    delete subElement.isEditing;
                    delete subElement.elements;
                    delete subElement.editing_elements;
                    delete subElement.editing_name;
                    delete subElement.editing_type;
                    delete subElement.editing_asIsToBe
                    delete subElement.editing_weight;
                    delete subElement.weight;
                    delete subElement.isExist;                   
                  }else if(subElement.type==="paneldynamic"){
                      const valueObj = {};
                      subElement.templateElements.forEach((te) => {
                          valueObj[te.name] = ""; // boş başlangıç değeri
                          delete te.editing_type;
                          delete te.elements;
                          delete te.editing_elements;
                          delete te.editing_name;
                          delete te.editing_type;
                          delete te.editing_asIsToBe
                          delete te.editing_weight;
                          delete te.weight;
                          delete te.is_exist;    
                          delete te.isEditing;
                          te.visible = true
                          te.title =te.title
                          if (te.asIsToBe && (te.type === "radiogroup" || te.type === "dropdown" || te.type === "rating")){
                            const tempType = te.type
                            te.type = "matrixdropdown";
                            te.titleLocation = "hidden";
                            te.columns = []
                            if (tempType !== "rating"){
                              te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  choices: te.choices
                                },
                              ]
                            }else{
                               te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  rateCount: te.rateCount,
                                  rateType: te.rateType,
                                  rateMax : subElement.rateMax,
                                  displayMode : subElement.buttons
                                },
                              ]
                            }
                           
                            te.rows = [
                              { text: "Current", value: "Current" },
                              { text: "Target", value: "Target" }
                            ]
                            te.transposeData = true;
                          }
                          else if (te.type === "matrixdropdown") {
                            te.type =  te.columns.cellType;
                            te.titleLocation = "top";
                            te.choices = te.columns[0].choices;
                            delete te.rows;
                            delete te.columns;
                            delete te.transposeData;
                            delete te.editing_type;
                            delete te.isEditing;
                            delete te.elements;
                            delete te.editing_elements;
                            delete te.editing_name;
                            delete te.editing_type;
                            delete te.editing_asIsToBe
                            delete te.editing_weight;
                            delete te.weight;
                            delete te.isExist;                   
                          }

                      });

                      subElement.value = [valueObj];
                      subElement.panelCount = 1  
                      subElement.readOnly= false
                      subElement.allowAddPanel= false
                      subElement.allowRemovePanel=false
                    }
               });
             }
           });
         });
       }
       return _currentSurvey;
  };

    let survey = useMemo(() => new Model(surveyJson), [surveyJson]);
    const question = survey.getQuestionByName("Question");
    if (question && question.panels.length === 0) {
        question.addPanel(); 
    }
    survey.applyTheme(themeJson);
    survey.propertyHash.showTOC = false;

    useEffect(() => {
        userSurveyRef.current = userSurvey; // State her değiştiğinde ref'i güncelle
    }, [userSurvey]);

    useEffect(() => {
        surveyJsonRef.current = surveyJson; // State her değiştiğinde ref'i güncelle
    }, [surveyJson]);

    function getQuestionName(questions, question_id) {
        return questions.find(q => q.ID == question_id).question;
    }

    function arrangeSurveyContent(questions, element) {
        if (element.type == 'panel') {
            element.elements.forEach(subElement => {
                arrangeSurveyContent(questions, subElement);
            });
        } else if (element.type == 'matrix') {
            element.rows.forEach(row => {
                row.text = getQuestionName(questions, row.value);
            });
        } else if (element.type == 'radiogroup') {
            element.title = getQuestionName(questions, element.name);
        } else if (element.type == 'text') {
            element.title = getQuestionName(questions, element.name);
        } else if (element.type == 'dropdown') {
            element.title = getQuestionName(questions, element.name);
        }
        return element;
    }

    async function getUserSurvey() {
        try {
            let result = await getUserSurveyFromAPI(user_survey_id);
            console.log("result",result)
            setUserSurvey(result["survey"]);
            let arrangedSurvey=arrangeSurvey(result["survey"].survey_content)
            setSurveyJson(arrangedSurvey);
            setPage404(false);
            // });        
        } catch (error) {
            console.log("user survey gelmedi")
        }
    }

    const updateTOCVisibility = (survey) => {
        if (survey && survey.propertyHash) {
            const isFirstPage = survey.currentPageNo === 0;
            survey.propertyHash.showTOC = !isFirstPage;
        }
    };

    async function sendAnswers(surveySenderData) {
        surveySenderData = JSON.parse(localStorage.getItem("surveySenderData"));
        const cleanedAnswers = {};

    for (const key in surveySenderData.answers) {
    const value = surveySenderData.answers[key];

    // 🟢 1. Eğer doğrudan Current/Target yapısı varsa
    if (
        typeof value === "object" &&
        value !== null &&
        ("Current" in value || "Target" in value)
    ) {
        // İçte Current/Target obje olabilir, doğrudan değer olabilir
        const currentVal =
            typeof value.Current === "object" && value.Current !== null
                ? value.Current?.[key]
                : value.Current;
        const targetVal =
            typeof value.Target === "object" && value.Target !== null
                ? value.Target?.[key]
                : value.Target;

        cleanedAnswers[key] = {
            ...(currentVal !== undefined && { Current: currentVal }),
            ...(targetVal !== undefined && { Target: targetVal }),
        };
    }

    // 🟢 2. Eğer array veya nested obje varsa
    else if (typeof value === "object" && value !== null) {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (typeof item === "object" && item !== null) {
                    for (const innerKey in item) {
                        const innerVal = item[innerKey];

                        // Eğer innerVal Current/Target içeriyorsa onu da yakala
                        if (
                            typeof innerVal === "object" &&
                            innerVal !== null &&
                            ("Current" in innerVal || "Target" in innerVal)
                        ) {
                            cleanedAnswers[innerKey] = {
                                ...(innerVal.Current !== undefined && { Current: innerVal.Current }),
                                ...(innerVal.Target !== undefined && { Target: innerVal.Target }),
                            };
                        } else if (Array.isArray(innerVal)) {
                            innerVal.forEach((lvl2) => {
                                if (typeof lvl2 === "object" && lvl2 !== null) {
                                    for (const lvl2Key in lvl2) {
                                        cleanedAnswers[lvl2Key] = lvl2[lvl2Key];
                                    }
                                } else {
                                    cleanedAnswers[innerKey] = lvl2;
                                }
                            });
                        } else if (typeof innerVal === "object" && innerVal !== null) {
                            for (const lvl2Key in innerVal) {
                                cleanedAnswers[lvl2Key] = innerVal[lvl2Key];
                            }
                        } else {
                            cleanedAnswers[innerKey] = innerVal;
                        }
                    }
                }
            });
        } else {
            // basit nested obje
            for (const k in value) {
                cleanedAnswers[k] = value[k];
            }
        }
    }

    // 🟢 3. Basit değer ise direkt ata
    else {
        cleanedAnswers[key] = value;
    }
}

        surveySenderData.answers=cleanedAnswers
        updateUserSurveyFromAPI(userSurveyRef.current.ID, surveySenderData).then((result) => {
        }).catch((error) => {
        });

        let _answers = [];
        for (var key in surveySenderData.answers) {
            let _answer = {}
            const _pages = surveyJsonRef.current.pages.filter(page => page.name !== "intro");
            for (var i = 0; i < _pages.length; i++) {
                _answer["section"] = _pages[i].title;
                for (var j = 0; j < _pages[i].elements[0].elements.length; j++) {
                    if(_pages[i].elements[0].elements[j].type !== "html"){
                        if( _pages[i].elements[0].elements[j].type !== "paneldynamic"){
                        }
                    }
                    if (_pages[i].elements[0].elements[j].type === "html") {
                        _answer["page"] = _pages[i].elements[0].elements[j].name;
                    }else if(_pages[i].elements[0].elements[j].type === "paneldynamic"){
                        const panelQuestion = _pages[i].elements[0].elements[j];   
                        panelQuestion.templateElements.forEach((tmpl, index) => {
                            if(tmpl["name"] === key ){
                                _answer["question_id"] = key;
                                _answer["question"] =tmpl.title;
                                _answer["type"] =tmpl.transposeData?tmpl.columns[0].cellType:tmpl.type;
                                _answer["weight"] =tmpl.weight || 1.0;
                                if (tmpl.type === "rating") {
                                    _answer["rateCount"] = tmpl.rateCount;
                                    _answer["answer"] = surveySenderData.answers[key]
                                }
                                if (tmpl.type === "radiogroup" || tmpl.type === "dropdown") {
                                    _answer["answer"] = tmpl.choices.find(choice => choice === surveySenderData.answers[key]).text;
                                    if (tmpl.choices.find(choice => choice === surveySenderData.answers[key]).weight !== undefined) {
                                        _answer["optionWeight"] = parseFloat(tmpl.choices.find(choice => choice === surveySenderData.answers[key]).weight);
                                    }
                                    _answer["options"] = tmpl.choices.map(choice => choice);
                                } else if (tmpl.type === "checkbox" || tmpl.type === "tagbox"
                                    || tmpl.type === "ranking") {
                                    _answer["answer"] = [];
                                    for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                        if (tmpl.choices.find(choice => choice === surveySenderData.answers[key][k])) {
                                            _answer["answer"].push(tmpl.choices.find(choice => choice === surveySenderData.answers[key][k]).text);
                                        } else if (surveySenderData.answers[key][k] === 'other') {
                                            _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                        } else {
                                            _answer["answer"].push(surveySenderData.answers[key][k]);
                                        }
                                    }
                                    _answer["options"] = tmpl.choices.map(choice => choice);
                                }else if (tmpl.type === "matrixdropdown") {
                                    if(tmpl?.columns[0]?.cellType==="radiogroup" || tmpl.columns[0]?.cellType === "dropdown"){
                                        const choices = tmpl.choices;
                                        const getText = val => choices.find(choice => choice === val)?.text;
                                        const answerData = surveySenderData.answers[key];
                                        let currentVal;
                                        if (typeof answerData.Current === 'object') {
                                            // Eğer Current bir obje ise, key'i kullanarak değeri al
                                            currentVal = answerData.Current?.[key];
                                        } else {
                                            // Eğer Current bir obje değilse, direkt Current'ı al
                                            currentVal = answerData.Current;
                                        }

                                        let targetVal;
                                        if (typeof answerData.Target === 'object') {
                                            // Eğer Target bir obje ise, key'i kullanarak değeri al
                                            targetVal = answerData.Target?.[key];
                                        } else {
                                            // Eğer Target bir obje değilse, direkt Target'ı al
                                            targetVal = answerData.Target;
                                        }

                                        let currentText = currentVal ? getText(currentVal) : null;
                                        let targetText = targetVal ? getText(targetVal) : null;
                                        _answer["options"] = tmpl.choices.map(choice => choice);
                                        _answer["answer"] = {
                                            ...(currentText !== undefined && { Current: currentText }),
                                            ...(targetText !== undefined && { Target: targetText }),
                                        };
                                        const currentWeight = currentVal !== undefined
                                        ? choices.find(choice => choice === currentVal)?.weight
                                        : undefined;

                                        const targetWeight = targetVal !== undefined
                                        ? choices.find(choice => choice === targetVal)?.weight
                                        : undefined;

                                        if (currentWeight !== undefined || targetWeight !== undefined) {
                                        _answer["optionWeight"] = {
                                            ...(currentWeight !== undefined && { Current: parseFloat(currentWeight) }),
                                            ...(targetWeight !== undefined && { Target: parseFloat(targetWeight) }),
                                        };
        }

                                    }else if (tmpl.columns[0].cellType === "rating") {
                                        _answer["rateCount"] = tmpl.rateCount;
                                           const answerData = surveySenderData.answers[key];
                                        let currentVal;
                                        if (typeof answerData.Current === 'object') {
                                            // Eğer Current bir obje ise, key'i kullanarak değeri al
                                            currentVal = answerData.Current?.[key];
                                        } else {
                                            // Eğer Current bir obje değilse, direkt Current'ı al
                                            currentVal = answerData.Current;
                                        }

                                        let targetVal;
                                        if (typeof answerData.Target === 'object') {
                                            // Eğer Target bir obje ise, key'i kullanarak değeri al
                                            targetVal = answerData.Target?.[key];
                                        } else {
                                            // Eğer Target bir obje değilse, direkt Target'ı al
                                            targetVal = answerData.Target;
                                        }

                                        let currentText = currentVal 
                                        let targetText = targetVal 
                                        _answer["answer"] = {
                                            ...(currentText !== undefined && { Current: currentText }),
                                            ...(targetText !== undefined && { Target: targetText }),
                                        };
                                    }
                                    else if (tmpl.columns[0].cellType === "checkbox" || tmpl.columns[0].cellType === "tagbox"
                                        || tmpl.columns[0].cellType === "ranking") {
                                        _answer["answer"] = [];
                                        for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                            if (tmpl.choices.find(choice => choice === surveySenderData.answers[key][k])) {
                                                _answer["answer"].push(tmpl.choices.find(choice => choice === surveySenderData.answers[key][k]).text);
                                            } else if (surveySenderData.answers[key][k] === 'other') {
                                                _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                            } else {
                                                _answer["answer"].push(surveySenderData.answers[key][k]);
                                            }
                                        }
                                        _answer["options"] = tmpl.choices.map(choice => choice);
                                    }
                                    // _answer["answer"] = surveySenderData.answers[key];
                                }
                                _answers.push(_answer);
                                j = _pages[i].elements[0].elements.length;
                                i = _pages.length - 1;
                            } else if(tmpl.type === "paneldynamic"){
                              
                                    const panelQuestion = tmpl;   
                                    panelQuestion.templateElements.forEach((tmplLvl2, index) => {
                                        if(tmplLvl2["name"] === key ){
                                            _answer["question_id"] = key;
                                            _answer["question"] =tmplLvl2.title;
                                            _answer["type"] =tmplLvl2.transposeData?tmplLvl2.columns[0].cellType:tmplLvl2.type;
                                            _answer["weight"] =tmplLvl2.weight || 1.0;
                                            if (tmplLvl2.type === "rating") {
                                                _answer["rateCount"] = tmplLvl2.rateCount;
                                                _answer["answer"] = surveySenderData.answers[key]
                                            }
                                            if (tmplLvl2.type === "radiogroup" || tmplLvl2.type === "dropdown") {
                                                _answer["answer"] = tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key]).text;
                                                if (tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key]).weight !== undefined) {
                                                    _answer["optionWeight"] = parseFloat(tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key]).weight);
                                                }
                                                _answer["options"] = tmplLvl2.choices.map(choice => choice);
                                            } else if (tmplLvl2.type === "checkbox" || tmplLvl2.type === "tagbox"
                                                || tmplLvl2.type === "ranking") {
                                                _answer["answer"] = [];
                                                for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                                    if (tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key][k])) {
                                                        _answer["answer"].push(tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key][k]).text);
                                                    } else if (surveySenderData.answers[key][k] === 'other') {
                                                        _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                                    } else {
                                                        _answer["answer"].push(surveySenderData.answers[key][k]);
                                                    }
                                                }
                                                _answer["options"] = tmplLvl2.choices.map(choice => choice);
                                            } else if(tmplLvl2.type === "paneldynamic"){

                                            }else if (tmplLvl2.type === "matrixdropdown") {
                                                if(tmplLvl2?.columns[0]?.cellType==="radiogroup" || tmplLvl2.columns[0]?.cellType === "dropdown"){
                                                    const choices = tmplLvl2.choices;
                                                    const getText = val => choices.find(choice => choice === val)?.text;
                                                    const answerData = surveySenderData.answers[key];
                                                    let currentVal;
                                                    if (typeof answerData.Current === 'object') {
                                                        // Eğer Current bir obje ise, key'i kullanarak değeri al
                                                        currentVal = answerData.Current?.[key];
                                                    } else {
                                                        // Eğer Current bir obje değilse, direkt Current'ı al
                                                        currentVal = answerData.Current;
                                                    }

                                                    let targetVal;
                                                    if (typeof answerData.Target === 'object') {
                                                        // Eğer Target bir obje ise, key'i kullanarak değeri al
                                                        targetVal = answerData.Target?.[key];
                                                    } else {
                                                        // Eğer Target bir obje değilse, direkt Target'ı al
                                                        targetVal = answerData.Target;
                                                    }

                                                    let currentText = currentVal ? getText(currentVal) : null;
                                                    let targetText = targetVal ? getText(targetVal) : null;
                                                    _answer["options"] = tmplLvl2.choices.map(choice => choice);
                                                    _answer["answer"] = {
                                                        ...(currentText !== undefined && { Current: currentText }),
                                                        ...(targetText !== undefined && { Target: targetText }),
                                                    };
                                                    const currentWeight = currentVal !== undefined
                                                    ? choices.find(choice => choice === currentVal)?.weight
                                                    : undefined;

                                                    const targetWeight = targetVal !== undefined
                                                    ? choices.find(choice => choice === targetVal)?.weight
                                                    : undefined;

                                                    if (currentWeight !== undefined || targetWeight !== undefined) {
                                                    _answer["optionWeight"] = {
                                                        ...(currentWeight !== undefined && { Current: parseFloat(currentWeight) }),
                                                        ...(targetWeight !== undefined && { Target: parseFloat(targetWeight) }),
                                                    };
                    }

                                                }else if (tmplLvl2.columns[0].cellType === "rating") {
                                                    _answer["rateCount"] = tmplLvl2.rateCount;
                                                    const answerData = surveySenderData.answers[key];
                                                    let currentVal;
                                                    if (typeof answerData.Current === 'object') {
                                                        // Eğer Current bir obje ise, key'i kullanarak değeri al
                                                        currentVal = answerData.Current?.[key];
                                                    } else {
                                                        // Eğer Current bir obje değilse, direkt Current'ı al
                                                        currentVal = answerData.Current;
                                                    }

                                                    let targetVal;
                                                    if (typeof answerData.Target === 'object') {
                                                        // Eğer Target bir obje ise, key'i kullanarak değeri al
                                                        targetVal = answerData.Target?.[key];
                                                    } else {
                                                        // Eğer Target bir obje değilse, direkt Target'ı al
                                                        targetVal = answerData.Target;
                                                    }

                                                    let currentText = currentVal
                                                    let targetText = targetVal
                                                    _answer["answer"] = {
                                                        ...(currentText !== undefined && { Current: currentText }),
                                                        ...(targetText !== undefined && { Target: targetText }),
                                                    };

                                                }
                                                else if (tmplLvl2.columns[0].cellType === "checkbox" || tmplLvl2.columns[0].cellType === "tagbox"
                                                    || tmplLvl2.columns[0].cellType === "ranking") {
                                                    _answer["answer"] = [];
                                                    for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                                        if (tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key][k])) {
                                                            _answer["answer"].push(tmplLvl2.choices.find(choice => choice === surveySenderData.answers[key][k]).text);
                                                        } else if (surveySenderData.answers[key][k] === 'other') {
                                                            _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                                        } else {
                                                            _answer["answer"].push(surveySenderData.answers[key][k]);
                                                        }
                                                    }
                                                    _answer["options"] = tmplLvl2.choices.map(choice => choice);
                                                }
                                                // _answer["answer"] = surveySenderData.answers[key];
                                            }
                                            _answers.push(_answer);
                                            j = _pages[i].elements[0].elements.length;
                                            i = _pages.length - 1;
                                        }
                                    })
                            }
                        })
                    }else if (_pages[i].elements[0].elements[j].elements[0].name === key) {
                        _answer["question_id"] = key;
                        _answer["question"] = _pages[i].elements[0].elements[j].elements[0].title;
                        _answer["type"] = _pages[i].elements[0].elements[j].elements[0].transposeData? _pages[i].elements[0].elements[j].elements[0].columns[0].cellType:_pages[i].elements[0].elements[j].elements[0].type;
                        _answer["weight"] = _pages[i].elements[0].elements[j].elements[0].weight || 1.0;
                        if (_pages[i].elements[0].elements[j].elements[0].type === "rating") {
                            _answer["rateCount"] = _pages[i].elements[0].elements[j].elements[0].rateCount;
                            _answer["answer"] = surveySenderData.answers[key]
                        }
                        if (_pages[i].elements[0].elements[j].elements[0].type === "radiogroup" || _pages[i].elements[0].elements[j].elements[0].type === "dropdown") {
                            console.log(_pages[i].elements[0].elements[j].elements[0],surveySenderData.answers[key])
                            _answer["answer"] = _pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key]);
                            console.log( _answer["answer"] )
                            if (_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key]).weight !== undefined) {
                                _answer["optionWeight"] = parseFloat(_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key]).weight);
                            }
                            _answer["options"] = _pages[i].elements[0].elements[j].elements[0].choices.map(choice => choice);
                        } else if (_pages[i].elements[0].elements[j].elements[0].type === "checkbox" || _pages[i].elements[0].elements[j].elements[0].type === "tagbox"
                            || _pages[i].elements[0].elements[j].elements[0].type === "ranking") {
                            _answer["answer"] = [];
                            for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                if (_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key][k])) {
                                    _answer["answer"].push(_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key][k]).text);
                                } else if (surveySenderData.answers[key][k] === 'other') {
                                    _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                } else {
                                    _answer["answer"].push(surveySenderData.answers[key][k]);
                                }
                            }
                            _answer["options"] = _pages[i].elements[0].elements[j].elements[0].choices.map(choice => choice);
                        } else if (_pages[i].elements[0].elements[j].elements[0].type === "matrixdropdown") {
                            if(_pages[i].elements[0].elements[j].elements[0].columns[0].cellType==="radiogroup" || _pages[i].elements[0].elements[j].elements[0].columns[0].cellType === "dropdown" ){
                                const choices = _pages[i].elements[0].elements[j].elements[0].choices;
                                const getText = val => choices.find(choice => choice === val)?.text;
                                const answerData = surveySenderData.answers[key];
                                let currentVal;
                                if (typeof answerData.Current === 'object') {
                                    // Eğer Current bir obje ise, key'i kullanarak değeri al
                                    currentVal = answerData.Current?.[key];
                                } else {
                                    // Eğer Current bir obje değilse, direkt Current'ı al
                                    currentVal = answerData.Current;
                                }

                                let targetVal;
                                if (typeof answerData.Target === 'object') {
                                    // Eğer Target bir obje ise, key'i kullanarak değeri al
                                    targetVal = answerData.Target?.[key];
                                } else {
                                    // Eğer Target bir obje değilse, direkt Target'ı al
                                    targetVal = answerData.Target;
                                }

                                let currentText = currentVal ? getText(currentVal) : null;
                                let targetText = targetVal ? getText(targetVal) : null;
                                _answer["options"] = _pages[i].elements[0].elements[j].elements[0].choices.map(choice => choice);
                                _answer["answer"] = {
                                    ...(currentText !== undefined && { Current: currentText }),
                                    ...(targetText !== undefined && { Target: targetText }),
                                  };
                                const currentWeight = currentVal !== undefined
                                ? choices.find(choice => choice === currentVal)?.weight
                                : undefined;

                                const targetWeight = targetVal !== undefined
                                ? choices.find(choice => choice === targetVal)?.weight
                                : undefined;

                                if (currentWeight !== undefined || targetWeight !== undefined) {
                                _answer["optionWeight"] = {
                                    ...(currentWeight !== undefined && { Current: parseFloat(currentWeight) }),
                                    ...(targetWeight !== undefined && { Target: parseFloat(targetWeight) }),
                                };
}

                            }else if (_pages[i].elements[0].elements[j].elements[0].columns[0].cellType === "rating") {
                                _answer["rateCount"] = _pages[i].elements[0].elements[j].elements[0].rateCount;
                                const answerData = surveySenderData.answers[key];
                                let currentVal;
                                if (typeof answerData.Current === 'object') {
                                    // Eğer Current bir obje ise, key'i kullanarak değeri al
                                    currentVal = answerData.Current?.[key];
                                } else {
                                    // Eğer Current bir obje değilse, direkt Current'ı al
                                    currentVal = answerData.Current;
                                }

                                let targetVal;
                                if (typeof answerData.Target === 'object') {
                                    // Eğer Target bir obje ise, key'i kullanarak değeri al
                                    targetVal = answerData.Target?.[key];
                                } else {
                                    // Eğer Target bir obje değilse, direkt Target'ı al
                                    targetVal = answerData.Target;
                                }

                                let currentText = currentVal
                                let targetText = targetVal
                                _answer["answer"] = {
                                    ...(currentText !== undefined && { Current: currentText }),
                                    ...(targetText !== undefined && { Target: targetText }),
                                  };
                            }
                            else if (_pages[i].elements[0].elements[j].elements[0].columns[0].cellType === "checkbox" || _pages[i].elements[0].elements[j].elements[0].columns[0].cellType === "tagbox"
                                || _pages[i].elements[0].elements[j].elements[0].columns[0].cellType === "ranking") {
                                _answer["answer"] = [];
                                for (var k = 0; k < surveySenderData.answers[key].length; k++) {
                                    if (_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key][k])) {
                                        _answer["answer"].push(_pages[i].elements[0].elements[j].elements[0].choices.find(choice => choice === surveySenderData.answers[key][k]).text);
                                    } else if (surveySenderData.answers[key][k] === 'other') {
                                        _answer["answer"].push(surveySenderData.answers[key + '-Comment']);
                                    } else {
                                        _answer["answer"].push(surveySenderData.answers[key][k]);
                                    }
                                }
                                _answer["options"] = _pages[i].elements[0].elements[j].elements[0].choices.map(choice => choice);
                            }
                            // _answer["answer"] = surveySenderData.answers[key];
                        }
                        _answers.push(_answer);
                        j = _pages[i].elements[0].elements.length;
                        i = _pages.length - 1;
                    }
                }
            }
        }

        updateSurveyResult(_answers);
    }

    useEffect(() => {
        getUserSurvey();
        localStorage.setItem("surveySenderData", JSON.stringify({}));
        localStorage.setItem("lastSendedSurveySenderData", JSON.stringify({}));

        intervalRef.current = setInterval(() => {
            const surveySenderData = localStorage.getItem("surveySenderData");
            const lastSendedSurveySenderData = localStorage.getItem("lastSendedSurveySenderData");
            if (surveySenderData !== lastSendedSurveySenderData) {
                sendAnswers(JSON.parse(surveySenderData));
                localStorage.setItem("lastSendedSurveySenderData", surveySenderData);
            }
        }, 10000);

        return () => clearInterval(intervalRef.current); // Bileşen unmount olduğunda temizle
    }, []);

    const stopInterval = () => {
        clearInterval(intervalRef.current); // ✅ Interval’i durdur
    };

    useEffect(() => {
        function saveSurveyState(sender) {
            const stored = JSON.parse(localStorage.getItem("surveySenderData") || "{}");

            const mergedAnswers = {
                ...(stored.answers || {}),
                ...(sender.data || {})
            };

            const obj = {
                answers: mergedAnswers,
                is_started: true,
                current_page: sender.currentPageNo
            };

            localStorage.setItem("surveySenderData", JSON.stringify(obj));
        }
                // updateTOCVisibility(survey);
        survey.onCurrentPageChanged.add(function (survey, options) {
            // updateTOCVisibility(survey);
            const currentPage = survey.currentPage;

            if (currentPage) {
                var jsonObj = currentPage.elements[0].jsonObj.elements
                const subtitleElements = jsonObj.filter(element => element.type === "html").map(element => element.name);
                const elementsArray = Array.isArray(subtitleElements) ? subtitleElements : Array.from(subtitleElements);
                setTimeout(() => {
                    const tocList = document.querySelector('.sv-list');
                    if (tocList) {
                        tocList.innerHTML = '';
                        elementsArray.forEach(name => {
                            const listItem = document.createElement('li');
                            listItem.className = 'sv-list__item';
                            listItem.role = 'option';
                            listItem.setAttribute('aria-selected', 'false');
                            listItem.tabIndex = 0;

                            const listItemBody = document.createElement('div');
                            listItemBody.className = 'sv-list__item-body';
                            listItemBody.title = name;
                            listItemBody.style.paddingInlineStart = '16px';

                            const span = document.createElement('span');
                            span.className = 'sv-string-viewer';
                            span.textContent = name;

                            listItemBody.appendChild(span);
                            listItem.appendChild(listItemBody);
                            tocList.appendChild(listItem);
                        });
                    }
                }, 0);
            }

        });
        survey.onProgressText.add(function (survey, options) {
            const currentPage = survey.currentPage;
            let totalQuestions = 0;
            let answeredQuestions = 0;

            if (currentPage) {
                totalQuestions = currentPage.questions.length;
                currentPage.questions.forEach(function (question) {
                    if (question.isAnswered) {
                        answeredQuestions++;
                    }
                });
                const pageTitle = currentPage.name || "Page";

                options.text = `${pageTitle} - Answered Questions: ${answeredQuestions}/${totalQuestions}`;

            }
        });

        survey.onComplete.add((sender, options) => {
            stopInterval();
            sendAnswers(JSON.parse(localStorage.getItem("surveySenderData")));
            completeSurvey();
        });

        // survey.onValueChanged.add(function (sender) {
            
        //     console.log("seneder",sender)
        //     const obj = {
        //         answers: sender.data,
        //         is_started: true,
        //         current_page: sender.currentPageNo
        //     }
        //     console.log('onValueChanged obj:', obj);
        //     localStorage.setItem("surveySenderData", JSON.stringify(obj));
        // });

        survey.onStarted.add(function (sender) {
            if (userSurvey.answers && Object.keys(userSurvey.answers).length > 0) {
                survey.data = userSurvey.answers;
                survey.currentPageNo = userSurvey.current_page;
            }
        });
        survey.onValueChanged.add(saveSurveyState);
survey.onDynamicPanelValueChanged.add(saveSurveyState);
        // survey.onDynamicPanelValueChanged.add(function (sender, options) {
        //     console.log(sender.data)
        //     const panelQuestion = options.question;         // paneldynamic sorusu
        //     const panelIndex = options.panelIndex;          // değişen satırın indexi
        //     const changedName = options.name;               // değişen alt soru name'i
        //     const newValue = options.value;                 // yeni değer

        //     console.log(
        //         `Panel: ${panelQuestion.name}, Satır: ${panelIndex}, Soru: ${changedName}, Değer: ${newValue}`
        //     );
        //      const obj = {
        //         answers: sender.data,
        //         is_started: true,
        //         current_page: sender.currentPageNo
        //     }
        //     console.log('onValueChanged obj:', obj);
        //     localStorage.setItem("surveySenderData", JSON.stringify(obj));
        // });


        // survey.onCurrentPageChanged.add((sender) => {
        //     if (!surveyStarted && sender.currentPageNo === 0) {
        //         setSurveyStarted(true);

        //         if (userSurvey.answers && Object.keys(userSurvey.answers).length > 0) {
        //             survey.data = userSurvey.answers;
        //             survey.currentPageNo = userSurvey.current_page;
        //         }
        //     } else if (surveyStarted || userSurvey.survey_content.firstPageIsStarted) {
        //         const obj = {
        //             answers: survey.data,
        //             is_started: true,
        //             current_page: sender.currentPageNo
        //         }
        //         updateUserSurveyFromAPI(userSurvey.ID, obj).then((result) => {
        //             console.log('update user survey result : ', result);
        //         }).catch((error) => {
        //             console.log('on current page changed error : ', error);
        //             // if (error.response.status == 404) {
        //             //     setPage404(true);
        //             // }
        //         });
        //     }
        // });
    })

    async function updateSurveyResult(surveyAnswers) {
        try {
            let obj = {
                user_survey_id: userSurveyRef.current.ID,
                user_id: userSurveyRef.current.user_id,
                survey_id: userSurveyRef.current.survey_id,
                answers: surveyAnswers
            }
            // console.log('updateSurveyResultFromAPI obj:', obj);
            await updateSurveyResultFromAPI(obj).then((result) => {
            }).catch((error) => {
                // console.log('add surveyresult error : ', error);
                // if (error.response.status == 404) {
                //     setPage404(true);
                // }
            });
        }
        catch (error) {
        }
    }

    async function completeSurvey() {
        const rows = [];

      
        // surveyResultsExcel(base64Excel)
        try {
            let obj = {
                user_survey_id: userSurvey.ID,
                survey_id: userSurvey.survey_id,
            }

            await completeSurveyResultFromAPI(obj).then((result) => {
            }).catch((error) => {
                // if (error.response.status == 404) {
                //     setPage404(true);
                // }
            });
        }
        catch (error) {
        }
    }

    return (
        <div className="survey-container">
            {page404 && 
            <div className={`min-h-screen flex items-center justify-center px-4 transition-colors duration-300
                       bg-gray-50`}>
                        <div className="max-w-2xl w-full text-center">
                            {/* 404 Numarası */}
                            <div className="relative">
                                <h1 className={`text-9xl font-bold mb-4 transition-colors duration-300 text-gray-200`}>
                                    404
                                </h1>
                                <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-6xl font-bold transition-colors duration-300 text-blue-600`}>
                                    404
                                </div>
                            </div>
            
                            {/* Başlık ve Açıklama */}
                            <h2 className={`text-3xl font-bold mb-4 transition-colors duration-300 text-gray-900`}>
                                Page Not Found
                            </h2>
                            <p className={`text-lg mb-8 transition-colors duration-300 text-gray-600`}>
                                The page you are looking for doesn't exist or has been moved. Please check the URL or return to the homepage.
                            </p>
            
                            {/* Butonlar */}
                            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                                {/* <button className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                                    isDark 
                                        ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                                        : 'bg-blue-600 hover:bg-blue-700 text-white'
                                }`}>
                                    <Home size={20} />
                                    Back to Home
                                </button>
                                
                                <button className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
                                    isDark 
                                        ? 'bg-gray-800 hover:bg-gray-700 text-white border border-gray-700' 
                                        : 'bg-white hover:bg-gray-100 text-gray-900 border border-gray-300'
                                }`}>
                                    <Search size={20} />
                                    Search
                                </button> */}
                            </div>
            
                            {/* Geri Dön Linki */}
                            {/* <button className={`flex items-center gap-2 mx-auto mt-8 transition-colors duration-300 ${
                                isDark 
                                    ? 'text-gray-400 hover:text-gray-300' 
                                    : 'text-gray-600 hover:text-gray-800'
                            }`}>
                                <ArrowLeft size={18} />
                                Go Back
                            </button>
             */}
                            {/* Dekoratif Elemanlar */}
                            <div className="mt-12 flex justify-center gap-2">
                                {[...Array(3)].map((_, i) => (
                                    <div
                                        key={i}
                                        className={`w-2 h-2 rounded-full transition-colors duration-300 bg-gray-300`}
                                        style={{
                                            animation: `pulse 1.5s ease-in-out ${i * 0.2}s infinite`
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
            
                        <style>{`
                            @keyframes pulse {
                                0%, 100% {
                                    opacity: 0.3;
                                    transform: scale(1);
                                }
                                50% {
                                    opacity: 1;
                                    transform: scale(1.2);
                                }
                            }
                        `}</style>
                    </div>
            }
            {/* {!page404 && <div> 
                Survey Gelecek <br />
            user_survey_id id : {user_survey_id} <br />
                </div>} */}
            {page404 == false && !userSurvey.is_completed && <Survey model={survey} />}
            {page404 == false && userSurvey.is_completed && (
                <div>
                    <h1>You already complete this survey!</h1>
                </div>
            )}
        </div>
    );
}

export default UserSurveyComponent;